export default {
    getGqlSchema: ()->
        return
    gqlModelStore: {}        
    getGqlModel: (options)->
        is_many = options.pk?
        key = options.app + options.model
        if gqlModelStore[key]?
             gqlModelStore[key].gql_model
        else
            gqlModelStore[key] = {
                gql_model_many: options.model+"_set"
                gql_model: options.model
                fields: []
            }
    buildModelQuery: (options)->
        #console.log("buildModelQuery", options)
        if not options.fields?
            # we could popoulate with default fields throw schema info...
            # would that be out of the graphql use flow?
            console.error("Not fields provded for query")
        if options.filters? and options.filters not in [""]
            return """
            query { #{options.model}( #{options.filters} ) {
                #{options.fields}
            }}
            """
        else
            return """
            query { #{options.model} {
                #{options.fields}
            }}
            """
    buildModelGetQuery: (options)->
        if not options.fields?
            # we could popoulate with default fields throw schema info...
            # would that be out of the graphql use flow?
            console.error("Not fields provded for query")
    
        return """
        query { #{options.model}(id: \"#{options.pk}\") {
            #{options.fields}
        }}
        """
    schemaQuery: "query IntrospectionQuery {
                  __schema {
                      queryType { name }
                      mutationType { name }
                      subscriptionType { name }
                      types {
                          ...FullType
                      }
                      directives {
                          name
                          description
                          locations
                          args {
                              ...InputValue
                          }
                      }
                  }
              }
              fragment FullType on __Type {
                  kind
                  name
                  description
                  fields(includeDeprecated: true) {
                      name
                      description
                      args {
                          ...InputValue
                      }
                      type {
                          ...TypeRef
                      }
                      isDeprecated
                      deprecationReason
                  }
                  inputFields {
                      ...InputValue
                  }
                  interfaces {
                      ...TypeRef
                  }
                  enumValues(includeDeprecated: true) {
                      name
                      description
                      isDeprecated
                      deprecationReason
                  }
                  possibleTypes {
                      ...TypeRef
                  }
              }
              fragment InputValue on __InputValue {
                  name
                  description
                  type { ...TypeRef }
                  defaultValue
              }
              fragment TypeRef on __Type {
                  kind
                  name
                  ofType {
                  kind
                  name
                  ofType {
                      kind
                      name
                      ofType {
                          kind
                          name
                          ofType {
                              kind
                              name
                              ofType {
                                  kind
                                  name
                                  ofType {
                                      kind
                                      name
                                      ofType {
                                          kind
                                          name
                                      }
                                  }
                              }
                          }
                      }
                  }
              }
          }"

}
